// Signout.js - Redux Ready
import { useEffect, createContext, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';

import reducer from '../Imports/reducerImports';
import { useShared } from '../Utilities/allContext1';

export default function SignOut(){

    const navigate = useNavigate();

    const { reset4SignIn, setCredential, setUsernameErrorMessage, setPasswordErrorMessage, setUsername, setPassword, setPasswordError, setUsernameError, setSupervisorList, setManagerList, setAssignList, setServiceList, setMemberList } = reducer;

    const dispatch = useDispatch(); // dispatch(
    //const credential = useSelector((state) => state.signIn.credential);

    useEffect(() => {
        dispatch(reset4SignIn());
        navigate('/signin');
    }, []);

    return (
        <Fragment>
        </Fragment>
    );

};